import classNames from 'classnames';
import { IconPokerCards } from '@medifind/icons';
import { Button } from '@medifind/shared-basic-components';
import { useClinicalTrialStepper } from '@medifind/zustand';
import RefineResultsFooter from './RefineResultsFooter';
import Step from './Step';
import styles from './StepShared.module.scss';

const RefineResultsStep = ({ stepKey, handleStepSubmit, showOptional, trialCount, loading }) => {
  const steps = useClinicalTrialStepper((state) => state.steps);
  const refineResultsStep = steps.find(({ key }) => key === stepKey);
  const { data, skip } = refineResultsStep || {};

  const onOptionChange = (selection) => {
    handleStepSubmit({ data: { ...selection } });
  };

  return (
    <Step
      title="Want help finding the best matches?"
      subTitle="Answer a few questions to customize your results."
      icon={<IconPokerCards />}
      footer={<RefineResultsFooter />}
      optionsColStyles={styles['refine-step']}
      showNext={skip || data?.value}
      showOptional={showOptional}
      trialCount={trialCount}
      showTrialCount
      loading={loading}
    >
      <div className={styles['btn-row']}>
        <Button
          className={classNames(styles['btn'])}
          onClick={() => onOptionChange({ display: 'Yes', value: 'Y' })}
          type="normal"
          label="Yes, Filter Results"
        />
        <Button
          className={classNames(styles['btn'])}
          onClick={() => onOptionChange({ display: 'No', value: 'N' })}
          type="normal"
          label="No, See All Results"
        />
      </div>
    </Step>
  );
};

export default RefineResultsStep;
